import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.SIGN_UP,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/SignUpContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'signUp', reducer: reducer.default })

    cb(null, module.default)
  }
})
